import React, { useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import InfiniteScroll from "react-infinite-scroll-component";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";
import { useMedia } from "react-use";
import {
  CloseCircleFilled,
  DownOutlined,
  ExclamationCircleFilled,
  MessageOutlined,
  SearchOutlined,
  UserAddOutlined,
  UserDeleteOutlined,
  UserOutlined,
} from "@ant-design/icons";
import { uuid } from "@ant-design/plots/es/utils";
import {
  Avatar,
  Button,
  Dropdown,
  Input,
  List,
  Modal,
  Select,
  Skeleton,
  Space,
  Tag,
  Tooltip,
  Typography,
} from "antd";
import {
  BlockCircleIcon,
  BoxIcon,
  DeleteUserIcon,
  EmailIcon,
  LockRedIcon,
  MuteIcon,
  SMSIcon,
  VoiceMailIcon,
  WhatsappIcon,
} from "assets/icons";
import {
  CONVERSATION_FILTER_TYPE,
  MESSAGE_TYPE,
  STORAGE_KEYS,
} from "constants/appConstant";
import { debounce } from "lodash";
import moment from "moment";
import { AuthInfo } from "stores/slices/auth";
import {
  doDeleteConversation,
  doGetConversationDetail,
  doGetConversationEvent,
  doGetConversationPage,
  doUpdateConversation,
  getConversationList,
  getConversationSelected,
  getNewConversation,
  isSaving,
  pageNumber,
  setConversationList,
  setConversationSelected,
  setParamsConversation,
  totalEls,
} from "stores/slices/conversation";
import {
  doCreateCustomer,
  doGetCustomerDetail,
  doUpdateCustomer,
} from "stores/slices/customer";
import { getCollapsed } from "stores/slices/layout";
import { setConversation } from "stores/slices/message";
import { getUserDetail, getUserList } from "stores/slices/user";
import StorageHelper from "utils/storeHelper";

import AddNewConversation from "components/addNewConversation/AddNewConversation";
import ModalForm from "components/forms/components/modalForm";

import OptInOrOutTable from "./optInOrOutTable";

import "../../../assets/styles/chatMessageStyle.scss";
const { confirm } = Modal;

const Conversation = props => {
  const {
    below768,
    params,
    setParams,
    filterStatusCon,
    isLoadingConversation,
  } = props;
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const urlParam = useParams();
  const over1024 = useMedia("(max-width: 1024px)");
  const authInfo = useSelector(AuthInfo);
  const userInfo = useSelector(getUserDetail);
  const conversationSelected = useSelector(getConversationSelected);
  const newConversation = useSelector(getNewConversation);
  const users = useSelector(getUserList);
  let conversationList = useSelector(getConversationList);

  const listConversation = useMemo(() => {
    let newConversationList = [];
    let newLastMessage;
    newConversationList = conversationList.map(conversation => {
      if (
        conversation.lastMessage === "" &&
        conversation.lastMessageDataType === "MEDIA" &&
        conversation.totalMediaContent > 0
      ) {
        switch (conversation.lastMessageMediaContentType) {
          case "IMAGE":
            newLastMessage = `Send ${
              conversation.totalMediaContent > 1
                ? conversation.totalMediaContent + " photos"
                : "a photo"
            }`;
            break;
          case "FILE":
            newLastMessage = `Send ${
              conversation.totalMediaContent > 1
                ? conversation.totalMediaContent + " files"
                : "a file"
            }`;
            break;
          case "VIDEO":
            newLastMessage = `Send ${
              conversation.totalMediaContent > 1
                ? conversation.totalMediaContent + " videos"
                : "a video"
            }`;
            break;
          case "AUDIO":
            newLastMessage = `Send ${
              conversation.totalMediaContent > 1
                ? conversation.totalMediaContent + " audio"
                : "a audio"
            }`;
            break;
          default:
            break;
        }
        conversation = {
          ...conversation,
          lastMessage: newLastMessage,
        };
        return conversation;
      }
      if (
        conversation &&
        conversation.lockUserId &&
        users &&
        users.length > 0
      ) {
        let index = users.findIndex(
          item => item.id === conversation.lockUserId
        );
        if (index !== -1) {
          let lockedName =
            users[index].firstName || users[index].lastName
              ? `${users[index].firstName || ""} ${users[index].lastName || ""}`
              : users[index].email;

          let newConversation = {
            ...conversation,
            userLocked: lockedName,
          };
          return newConversation;
        }
      }

      return conversation;
    });
    return newConversationList;
  }, [conversationList]);

  const currentConPage = useSelector(pageNumber);
  const totalElements = useSelector(totalEls);
  const collapsed = useSelector(getCollapsed);
  const isLoadingCon = useSelector(isSaving);
  const [openBroadcast, setOpenBroadcast] = useState(false);
  const [isRefreshTable, setIsRefreshTable] = useState("");
  const [isLoadMoreData, setIsLoadMoreData] = useState(false);
  const [searchConValue, setSearchConValue] = useState("");
  const [isSearch, setIsSearch] = useState(false);
  const [searchParam, setSearchParam] = useState({
    sortFiledBroadcastList: "createdTime",
    sortDirection: "DESC",
    pageNumber: 1,
    pageSize: 8,
  });

  const items = [
    {
      key: "1",
      label: (
        <span>
          {conversationSelected?.status === "DELETE"
            ? t("inbox.chatList.unarchive")
            : t("inbox.chatList.archive")}
        </span>
      ),
      icon: <BoxIcon />,
      onClick: () => {
        handleArchive(conversationSelected);
      },
      disabled:
        (conversationSelected?.broadcastScheduleId !== null &&
          conversationSelected?.broadcastScheduleId !== undefined) ||
        (conversationSelected?.lock &&
          conversationSelected?.lockSessionId !== authInfo?.sessionId),
    },
    {
      key: "2",
      label: <span>{t("inbox.chatList.optOutOrOut")}</span>,
      icon: <EmailIcon />,
      onClick: () => {
        setOpenBroadcast(true);
      },
      disabled:
        (conversationSelected?.lock &&
          conversationSelected?.lockSessionId !== authInfo?.sessionId) ||
        conversationSelected?.blockUser ||
        conversationSelected?.status === "DELETE" ||
        (conversationSelected?.broadcastScheduleId !== null &&
          conversationSelected?.broadcastScheduleId !== undefined),
    },
    {
      key: "3",
      label: (
        <span>
          {conversationSelected?.blockUser
            ? t("inbox.chatList.unblockUser")
            : t("inbox.chatList.blockUser")}
        </span>
      ),
      icon: <BlockCircleIcon />,
      onClick: () => {
        handleBlockUser(conversationSelected);
      },
      disabled:
        conversationSelected?.status === "DELETE" ||
        (conversationSelected?.broadcastScheduleId !== null &&
          conversationSelected?.broadcastScheduleId !== undefined) ||
        (conversationSelected?.lock &&
          conversationSelected?.lockSessionId !== authInfo?.sessionId),
    },
    {
      key: "4",
      label: (
        <span>
          {conversationSelected?.mute
            ? t("inbox.chatList.unMute")
            : t("inbox.chatList.mute")}
        </span>
      ),
      icon: <MuteIcon />,
      onClick: () => {
        handleMute(conversationSelected);
      },
      disabled:
        conversationSelected?.blockUser ||
        conversationSelected?.status === "DELETE" ||
        (conversationSelected?.broadcastScheduleId !== null &&
          conversationSelected?.broadcastScheduleId !== undefined) ||
        (conversationSelected?.lock &&
          conversationSelected?.lockSessionId !== authInfo?.sessionId),
    },
  ];

  const conversation = [
    {
      value: CONVERSATION_FILTER_TYPE.AWAITING_REPLIES,
      label: t("inbox.conversation.awaitingReplies"),
    },
    {
      value: CONVERSATION_FILTER_TYPE.MY_REPLIES,
      label: t("inbox.conversation.myReplies"),
    },
    {
      value: CONVERSATION_FILTER_TYPE.ARCHIVED,
      label: t("inbox.conversation.archived"),
    },
    {
      value: CONVERSATION_FILTER_TYPE.BLOCKED,
      label: t("inbox.conversation.blocked"),
    },
    {
      value: CONVERSATION_FILTER_TYPE.ALL,
      label: t("inbox.conversation.allConversations"),
    },
  ];

  const loadMoreData = async () => {
    setIsLoadMoreData(true);
    const { payload } = await dispatch(
      doGetConversationPage({
        ...params,
        pageNumber: currentConPage + 1,
      })
    );
    if (payload && payload.status === 200) {
      await dispatch(
        setConversationList([...conversationList, ...payload.data.content])
      );
      setIsLoadMoreData(false);
    }
  };

  const doListenConversationEv = async () => {
    if (authInfo && authInfo.workspaceId) {
      await dispatch(
        doGetConversationEvent({ workspaceId: authInfo.workspaceId })
      );
    }
  };

  const getDetailConversation = async id => {
    if (id) {
      const { payload } = await dispatch(doGetConversationDetail({ id: id }));
      if (payload && payload.status === 200) {
        await dispatch(setConversationSelected(payload.data));
        await dispatch(setConversation(payload.data));
      }
    }
  };

  const onClickConversation = async conversationItem => {
    await navigate(`/inbox/${conversationItem.id}`);
    await dispatch(setConversationSelected(conversationItem));
  };

  const handleArchive = data => {
    confirm({
      title:
        data?.status === "DELETE"
          ? t("inbox.chatList.unarchive")
          : t("inbox.chatList.archive"),
      icon: <ExclamationCircleFilled />,
      content:
        data?.status === "DELETE"
          ? t("inbox.chatList.unarchiveMsg")
          : t("inbox.chatList.archiveMsg"),
      okText: "Yes",
      okType: "danger",
      cancelText: "No",
      async onOk() {
        if (data?.status === "DELETE") {
          const request = {
            id: data.id,
            status: "ACTIVE",
          };
          await dispatch(doUpdateConversation(request));
          navigate("/inbox/messages");
        } else {
          const request = {
            id: data.id,
          };
          const { payload } = await dispatch(doDeleteConversation(request));
          if (payload && payload.status === 200) {
            navigate("/inbox/messages");
          }
        }
      },
      onCancel() {},
    });
  };

  const handleBlockUser = data => {
    confirm({
      title: data?.blockUser
        ? t("inbox.chatList.unblockUser")
        : t("inbox.chatList.blockUser"),
      icon: <ExclamationCircleFilled />,
      content: data?.blockUser
        ? t("inbox.chatList.unblockUserMsg")
        : t("inbox.chatList.blockUserMsg"),
      okText: "Yes",
      okType: "danger",
      cancelText: "No",
      async onOk() {
        const request = {
          isBlocked: !data?.blockUser,
        };
        const { payload } = await dispatch(
          doUpdateCustomer({ id: data?.customerId, data: request })
        );
        if (payload && payload.status === 200) {
          navigate("/inbox/messages");
        }
      },
      onCancel() {},
    });
  };

  const handleMute = data => {
    confirm({
      title: conversationSelected?.mute
        ? t("inbox.chatList.unMute")
        : t("inbox.chatList.mute"),
      icon: <ExclamationCircleFilled />,
      content: conversationSelected?.mute
        ? t("inbox.chatList.unMuteMsg")
        : t("inbox.chatList.muteMsg"),
      okText: "Yes",
      okType: "danger",
      cancelText: "No",
      async onOk() {
        const request = {
          id: data.id,
          muteConversation: !data.mute,
        };
        await dispatch(doUpdateConversation(request));
      },
      onCancel() {},
    });
  };

  const handleFilter = async value => {
    let newParams;
    if (authInfo && authInfo.workspaceId) {
      switch (value) {
        case CONVERSATION_FILTER_TYPE.AWAITING_REPLIES:
          newParams = {
            ...params,
            searchKey: "",
            sortDirection: "ASC",
            workspaceId: authInfo?.workspaceId,
            filterConversation: value,
          };
          if (value !== CONVERSATION_FILTER_TYPE.ALL) {
            setSearchConValue("");
          }
          break;
        case CONVERSATION_FILTER_TYPE.MY_REPLIES:
        case CONVERSATION_FILTER_TYPE.BLOCKED:
        case CONVERSATION_FILTER_TYPE.ARCHIVED:
        case CONVERSATION_FILTER_TYPE.ALL:
          newParams = {
            ...params,
            searchKey: "",
            sortDirection: "DESC",
            workspaceId: authInfo?.workspaceId,
            filterConversation: value,
          };
          if (value !== CONVERSATION_FILTER_TYPE.ALL) {
            setSearchConValue("");
          }
          break;
        default:
          newParams = {
            ...params,
            sortDirection: "DESC",
            workspaceId: authInfo?.workspaceId,
            filterConversation: value,
          };
          break;
      }

      await setParams(newParams);
    }
  };

  const handleInputChange = event => {
    const { value } = event.target;
    if (value) {
      setSearchConValue(value);
      handleSearch(value);
      setIsSearch(true);
    } else {
      // When search input is empty, filter status will change awaiting replies
      setSearchConValue(value);
      setIsSearch(false);
    }
  };

  const handleSearch = debounce(async value => {
    if (value) {
      const searchParams = {
        ...params,
        searchKey: value.trim(),
        filterConversation: CONVERSATION_FILTER_TYPE.ALL,
      };
      await dispatch(setParamsConversation(searchParams));
      await setParams(searchParams);
    }
  }, 300);

  const formatTimeAgo = seconds => {
    const browserLocale = navigator.language;
    const date = moment(seconds)
      ?.locale(browserLocale)
      ?.tz(userInfo?.timeZone ? userInfo?.timeZone : moment.tz.guess())
      ?.fromNow();
    return date;
  };

  // const formatTimeAgo = seconds => {
  //   const browserLocale = navigator.language;
  //   const date = moment(seconds)
  //     ?.locale(browserLocale, {
  //       relativeTime: {
  //         future: "in %s",
  //         past: "%s ago",
  //         s: "a few seconds",
  //         ss: "%d seconds",
  //         m: "a minute",
  //         mm: "%d minutes",
  //         h: "an hour",
  //         hh: "%d hours",
  //         d: "a day",
  //         dd: "%d days",
  //         w: "a week",
  //         ww: "%d weeks",
  //         M: "a month",
  //         MM: "%d months",
  //         y: "a year",
  //         yy: "%d years",
  //       },
  //     })
  //     ?.tz(userInfo?.timeZone ? userInfo?.timeZone : moment.tz.guess())
  //     ?.fromNow();
  //   return date;
  // };

  const handleOptInOrOut = async (broadcastListItem, conversationSelected) => {
    // Handle opt in or out
    if (broadcastListItem.broadcastListCustomer) {
      const request = {
        optin: !broadcastListItem?.broadcastListCustomer?.optin,
      };
      const { payload } = await dispatch(
        doUpdateCustomer({
          id: conversationSelected?.customerId,
          broadcastListId: broadcastListItem?.id,
          data: request,
        })
      );
      if (payload && payload.status === 200) {
        setIsRefreshTable(uuid());
      }
    } else {
      // Handle opt in new customer to broadcast list
      const { payload } = await dispatch(
        doGetCustomerDetail({
          id: conversationSelected?.customerId,
        })
      );
      if (payload && payload.status === 200) {
        const { contact } = payload.data;
        if (contact) {
          const request = {
            broadcastListId: broadcastListItem?.id,
            createCustomerAndContactRequests: [
              {
                phoneNumber: contact?.phoneNumber,
              },
            ],
          };
          const { payload } = await dispatch(doCreateCustomer(request));
          if (payload && payload.status === 200) {
            setIsRefreshTable(uuid());
          }
        }
      }
    }
  };

  const columns = [
    {
      title: t("broadcastList.title.listName"),
      width: 10,
      dataIndex: "name",
      key: "name",
      sorter: true,
      sortDirections: ["ascend", "descend"],
      isSearchable: true,
      ellipsis: {
        showTitle: false,
      },
    },
    {
      title: t("broadcastList.title.status"),
      width: 10,
      dataIndex: "status",
      key: "status",
      ellipsis: {
        showTitle: false,
      },
      render: (_, record) =>
        record?.broadcastListCustomer ? (
          <Tag
            color={record.broadcastListCustomer?.optin ? "#0E9154" : "#A9122B"}
            bordered={false}
          >
            {record.broadcastListCustomer?.optin
              ? t("customer.optedIn")
              : t("customer.optedOut")}
          </Tag>
        ) : (
          ""
        ),
    },
    {
      title: t("noticeBoard.actions"),
      key: "operation",
      width: 10,
      render: (_, record) => {
        return (
          <>
            <Space size="middle">
              <Tooltip
                title={
                  record.broadcastListCustomer?.optin
                    ? t("customer.optedOut")
                    : t("customer.optedIn")
                }
              >
                <Button
                  type="text"
                  shape="circle"
                  size="middle"
                  style={{
                    marginRight: 8,
                  }}
                  onClick={() => handleOptInOrOut(record, conversationSelected)}
                >
                  {record.broadcastListCustomer?.optin ? (
                    <UserDeleteOutlined />
                  ) : (
                    <UserAddOutlined />
                  )}
                </Button>
              </Tooltip>
            </Space>
          </>
        );
      },
    },
  ];

  useEffect(() => {
    if (authInfo && authInfo.workspaceId) {
      doListenConversationEv();
    }
    const { id } = urlParam;
    if (id && id !== "messages") {
      getDetailConversation(id);
    }
  }, []);

  useEffect(() => {
    if (newConversation && newConversation.id) {
      let index = listConversation.findIndex(
        item => item?.id === newConversation?.id
      );
      if (index !== -1) {
        listConversation[index] = newConversation;

        // Set conversation selected
        if (conversationSelected?.id === listConversation[index]?.id) {
          dispatch(setConversationSelected(listConversation[index]));
        }
        // Remove draft message when unlock conversation
        if (!listConversation[index]?.lock) {
          // dispatch(setCurrentLockConversation(false));
          StorageHelper.removeLocalItem(listConversation[index]?.id);
        }
        // Remove conversation to current list by status filter
        if (
          params.filterConversation !== undefined &&
          params.filterConversation !== null
        ) {
          switch (params.filterConversation) {
            case CONVERSATION_FILTER_TYPE.ALL:
            case CONVERSATION_FILTER_TYPE.AWAITING_REPLIES:
            case CONVERSATION_FILTER_TYPE.MY_REPLIES:
              if (
                listConversation[index].blockUser ||
                listConversation[index].status === "DELETE"
              ) {
                listConversation.splice(index, 1);
              }
              break;
            case CONVERSATION_FILTER_TYPE.BLOCKED:
              if (!listConversation[index].blockUser) {
                listConversation.splice(index, 1);
              }
              break;
            case CONVERSATION_FILTER_TYPE.ARCHIVED:
              if (listConversation[index].status !== "DELETE") {
                listConversation.splice(index, 1);
              }
              break;
          }
          if (
            params?.filterConversation ===
            CONVERSATION_FILTER_TYPE.AWAITING_REPLIES
          ) {
            listConversation.sort(function (a, b) {
              return new Date(a.sendTime) - new Date(b.sendTime);
            });
            dispatch(setConversationList(listConversation));
          } else {
            listConversation.sort(function (a, b) {
              // If both objects have a sendTime of null then they are considered equal return 0.
              if (a.sendTime === null && b.sendTime === null) {
                return 0;
              }
              // If an object has createTime as null, that object is placed before return -1 if a.sendTime is null.
              if (a.sendTime === null) {
                return -1;
              }
              // If an object has createTime as null, that object is placed before return 1 if b.sendTime is null.
              if (b.sendTime === null) {
                return 1;
              }
              return new Date(b.sendTime) - new Date(a.sendTime);
            });
            dispatch(setConversationList([...listConversation]));
          }
        }
      } else {
        if (!params?.searchKey || params?.searchKey === "") {
          let conversations = [];
          conversations = [...listConversation, newConversation];
          if (
            params.filterConversation !== undefined &&
            params.filterConversation !== null &&
            conversations &&
            conversations.length > 0
          ) {
            switch (params.filterConversation) {
              case CONVERSATION_FILTER_TYPE.AWAITING_REPLIES:
                let conversationAwaRepliesList = conversations.filter(item => {
                  if (
                    item?.status !== "DELETE" &&
                    !item?.blockUser &&
                    item?.totalAwaitingReplies > 0
                  ) {
                    return item;
                  }
                });
                conversations = [...conversationAwaRepliesList];
                break;
              case CONVERSATION_FILTER_TYPE.ALL:
              case CONVERSATION_FILTER_TYPE.MY_REPLIES:
                let conversationAllList = [];
                conversationAllList = conversations.filter(item => {
                  if (item?.status !== "DELETE" && !item?.blockUser) {
                    return item;
                  }
                });
                conversations = [...conversationAllList];
                break;
              case CONVERSATION_FILTER_TYPE.BLOCKED:
                let conversationBlockList = [];
                conversationBlockList = conversations.filter(item => {
                  if (item?.blockUser) {
                    return item;
                  }
                });
                conversations = [...conversationBlockList];
                break;
              case CONVERSATION_FILTER_TYPE.ARCHIVED:
                let conversationDeleteList = [];
                conversationDeleteList = conversations.filter(item => {
                  if (item.status === "DELETE" || item?.blockUser) {
                    return item;
                  }
                });
                conversations = [...conversationDeleteList];
                break;
            }
            if (
              params?.filterConversation ===
              CONVERSATION_FILTER_TYPE.AWAITING_REPLIES
            ) {
              dispatch(setConversationList([...conversations]));
            } else {
              conversations.sort(function (a, b) {
                return new Date(b.sendTime) - new Date(a.sendTime);
              });
              dispatch(setConversationList([...conversations]));
            }
          }
        }
      }
    }
  }, [
    newConversation?.id,
    // newConversation?.lastMessage,
    newConversation?.sendTime,
    newConversation?.lock,
    // newConversation?.lockSessionId,
    newConversation?.blockUser,
    newConversation?.mute,
    newConversation?.status,
    newConversation?.totalAwaitingReplies,
  ]);

  useEffect(() => {
    if (conversationSelected && conversationSelected.id) {
      StorageHelper.setLocalItem(
        STORAGE_KEYS.currentConversationId,
        conversationSelected.id
      );
    }
  }, [conversationSelected?.id]);

  useEffect(() => {
    if (!isSearch) {
      setTimeout(() => {
        handleFilter(CONVERSATION_FILTER_TYPE.AWAITING_REPLIES);
      }, 1000);
    }
  }, [isSearch]);

  return (
    <>
      <Space
        direction="vertical"
        size="middle"
        className="conversation-container"
        style={{
          width: "100%",
          height: "100%",
          borderTop: "1px solid #DEE1E5",
          borderBottom: "1px solid #DEE1E5",
          borderRight: "1px solid #DEE1E5",
          paddingTop: below768 ? "28px" : "0",
        }}
      >
        {below768 && (
          <div style={{ padding: "0 16px" }}>
            {isLoadingConversation && (
              <>
                <Skeleton.Input
                  active={isLoadingConversation}
                  size={"default"}
                  block={true}
                />
                <Skeleton.Input
                  active={isLoadingConversation}
                  size={"default"}
                  block={true}
                  style={{ marginTop: 10 }}
                />
                <div style={{ marginTop: 16 }}>
                  <Skeleton
                    loading={isLoadingConversation}
                    active
                    avatar
                  ></Skeleton>
                  <Skeleton
                    loading={isLoadingConversation}
                    active
                    avatar
                  ></Skeleton>
                  <Skeleton
                    loading={isLoadingConversation}
                    active
                    avatar
                  ></Skeleton>
                  <Skeleton
                    loading={isLoadingConversation}
                    active
                    avatar
                  ></Skeleton>
                </div>
              </>
            )}
            {!isLoadingConversation && (
              <>
                <div style={{ marginBottom: 10 }}>
                  <Select
                    defaultValue={CONVERSATION_FILTER_TYPE.AWAITING_REPLIES}
                    value={
                      filterStatusCon ||
                      CONVERSATION_FILTER_TYPE.AWAITING_REPLIES
                    }
                    onChange={handleFilter}
                    style={{ width: "100%" }}
                    options={conversation}
                    size="large"
                  />
                </div>
                <div style={{ display: "flex", alignItems: "center" }}>
                  <Input
                    size="large"
                    placeholder="Search"
                    value={searchConValue}
                    prefix={<SearchOutlined />}
                    onChange={e => {
                      handleInputChange(e);
                    }}
                  />
                  <div style={{ marginLeft: 12 }}>
                    <AddNewConversation />
                  </div>
                </div>
              </>
            )}
          </div>
        )}

        <>
          <div
            id="scrollableDiv"
            style={{
              height: "calc(100vh - 210px)",
              overflow: "auto",
            }}
          >
            {!isLoadingConversation && (
              <InfiniteScroll
                scrollableTarget="scrollableDiv"
                dataLength={listConversation?.length}
                next={loadMoreData}
                hasMore={
                  listConversation && listConversation.length < totalElements
                }
                loader={
                  <>
                    {isLoadMoreData && (
                      <div style={{ padding: "0 16px" }}>
                        <Skeleton
                          avatar
                          paragraph={{
                            rows: 2,
                          }}
                          active
                        />
                      </div>
                    )}
                  </>
                }
                endMessage={""}
              >
                <List
                  itemLayout={"horizontal"}
                  dataSource={listConversation}
                  loading={isLoadingCon}
                  className="conversation-list"
                  renderItem={conversationItem => (
                    <>
                      <List.Item
                        key={conversationItem?.id}
                        className={
                          conversationItem.id === urlParam.id ? "active" : ""
                        }
                        style={{
                          padding: "12px 16px 12px 10px",
                        }}
                      >
                        <div
                          onClick={() => {
                            onClickConversation(conversationItem);
                          }}
                          style={{
                            cursor: "pointer",
                            display: "flex",
                            alignItems: "center",
                            width: "100%",
                          }}
                        >
                          <div
                            className="conversation-user-info"
                            style={{
                              flexGrow: 1,
                              display: "flex",
                              alignItems: "center",
                              position: "relative",
                              justifyContent: !below768 ? "center" : "",
                            }}
                          >
                            <Tooltip
                              title={
                                conversationItem &&
                                conversationItem.broadcastScheduleId &&
                                conversationItem.broadcastScheduleId !== null
                                  ? t("inbox.broadcastToNumberCustomers", {
                                      number:
                                        conversationItem &&
                                        conversationItem.totalBroadcastCustomer >
                                          99
                                          ? "99+"
                                          : conversationItem.totalBroadcastCustomer,
                                    })
                                  : conversationItem?.firstName ||
                                    conversationItem?.lastName
                                  ? `${conversationItem?.firstName || ""} ${
                                      conversationItem?.lastName || ""
                                    }`
                                  : conversationItem &&
                                    conversationItem.phoneNumber
                              }
                            >
                              {conversationItem &&
                                conversationItem.profileImage !== null &&
                                conversationItem.profileImage !== "" &&
                                (!conversationItem.broadcastScheduleId ||
                                  conversationItem.broadcastScheduleId ===
                                    null) && (
                                  <Avatar
                                    size={50}
                                    src={conversationItem.profileImage}
                                  />
                                )}
                              {conversationItem &&
                                (conversationItem.profileImage === null ||
                                  conversationItem.profileImage === "") &&
                                (!conversationItem.broadcastScheduleId ||
                                  conversationItem.broadcastScheduleId ===
                                    null) && (
                                  <Avatar size={50} icon={<UserOutlined />} />
                                )}
                              {conversationItem &&
                                conversationItem.broadcastScheduleId &&
                                conversationItem.broadcastScheduleId !==
                                  null && (
                                  <Avatar
                                    size={50}
                                    icon={<MessageOutlined />}
                                  />
                                )}
                            </Tooltip>
                            {conversationItem?.lastMessageType !== null &&
                              (conversationItem?.lastMessageType ===
                                MESSAGE_TYPE.SMS ||
                                conversationItem?.lastMessageType ===
                                  MESSAGE_TYPE.MMS) && (
                                <div
                                  style={{
                                    position: "absolute",
                                    left: below768 ? "34px" : "50px",
                                    top:
                                      conversationItem?.mute ||
                                      conversationItem?.spam
                                        ? "38px"
                                        : "34px",
                                  }}
                                >
                                  <SMSIcon />
                                </div>
                              )}
                            {conversationItem?.lastMessageType !== null &&
                              conversationItem?.lastMessageType ===
                                MESSAGE_TYPE.WHATSAPP && (
                                <div
                                  style={{
                                    position: "absolute",
                                    left: below768 ? "34px" : "50px",
                                    top:
                                      conversationItem?.mute ||
                                      conversationItem?.spam
                                        ? "38px"
                                        : "34px",
                                  }}
                                >
                                  <WhatsappIcon />
                                </div>
                              )}
                            {conversationItem?.lastMessageType ===
                              MESSAGE_TYPE.VOICE_MAIL && (
                              <div
                                style={{
                                  position: "absolute",
                                  left: below768 ? "34px" : "50px",
                                  top:
                                    conversationItem?.mute ||
                                    conversationItem?.spam
                                      ? "38px"
                                      : "34px",
                                }}
                              >
                                <VoiceMailIcon />
                              </div>
                            )}

                            {below768 && (
                              <div
                                style={{
                                  marginLeft: 12,
                                }}
                              >
                                <Typography.Text
                                  style={{
                                    display: "block",
                                    width: collapsed
                                      ? "250px"
                                      : over1024
                                      ? "110px"
                                      : "180px",
                                    maxWidth: "100%",
                                    whiteSpace: "nowrap",
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    fontSize: "14px",
                                    fontWeight:
                                      conversationItem?.totalUnread > 0
                                        ? "bold"
                                        : "600",
                                  }}
                                >
                                  {conversationItem &&
                                  conversationItem.broadcastScheduleId &&
                                  conversationItem.broadcastScheduleId !== null
                                    ? t("inbox.broadcastToNumberCustomers", {
                                        number:
                                          conversationItem &&
                                          conversationItem.totalBroadcastCustomer >
                                            99
                                            ? "99+"
                                            : conversationItem.totalBroadcastCustomer,
                                      })
                                    : conversationItem?.firstName ||
                                      conversationItem?.lastName
                                    ? `${conversationItem?.firstName || ""} ${
                                        conversationItem?.lastName || ""
                                      }`
                                    : conversationItem &&
                                      conversationItem.phoneNumber}
                                </Typography.Text>
                                <div>
                                  <Typography.Text
                                    style={{
                                      display: "block",
                                      width: collapsed
                                        ? "250px"
                                        : over1024
                                        ? "110px"
                                        : "180px",
                                      whiteSpace: "nowrap",
                                      overflow: "hidden",
                                      textOverflow: "ellipsis",
                                      fontSize: "12px",
                                      fontWeight:
                                        conversationItem?.totalUnread > 0
                                          ? "600"
                                          : "normal",
                                    }}
                                  >
                                    {conversationItem?.lastMessage}
                                  </Typography.Text>
                                </div>

                                <div className="conversation-user-icon">
                                  {conversationItem?.mute && <MuteIcon />}
                                  {conversationItem?.spam && <DeleteUserIcon />}
                                </div>
                              </div>
                            )}
                          </div>
                          {below768 && (
                            <>
                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: "space-around",
                                  alignItems: "center",
                                }}
                              >
                                <div
                                  style={{
                                    width: "110px",
                                    whiteSpace: "nowrap",
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    textAlign: "left",
                                  }}
                                >
                                  <Typography.Text
                                    style={{
                                      marginRight: "10px",
                                    }}
                                  >
                                    {conversationItem.sendTime
                                      ? formatTimeAgo(conversationItem.sendTime)
                                      : ""}
                                  </Typography.Text>
                                  {conversationItem?.blockUser ? (
                                    <div>
                                      <Tooltip title="Block user">
                                        <CloseCircleFilled
                                          style={{
                                            color: "#A9122B",
                                            fontSize: 30,
                                          }}
                                        />
                                      </Tooltip>
                                    </div>
                                  ) : (
                                    <div
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "flex-start",
                                      }}
                                    >
                                      {conversationItem?.totalAwaitingReplies >
                                      0 ? (
                                        <Tooltip
                                          title={`Awaiting replies (${conversationItem?.totalAwaitingReplies})`}
                                        >
                                          <div
                                            style={{
                                              borderRadius: "50%",
                                              width: 30,
                                              height: 30,
                                              backgroundColor: "#3A4CE8",
                                              color: "#fff",
                                              display: "flex",
                                              justifyContent: "center",
                                              alignItems: "center",
                                            }}
                                          >
                                            {conversationItem?.totalAwaitingReplies >
                                            99
                                              ? "99+"
                                              : conversationItem?.totalAwaitingReplies}
                                          </div>
                                        </Tooltip>
                                      ) : (
                                        <div
                                          style={{
                                            borderRadius: "50%",
                                            width: 30,
                                            height: 30,
                                            display: "flex",
                                            justifyContent: "center",
                                            alignItems: "center",
                                          }}
                                        ></div>
                                      )}
                                      {conversationItem?.lock && (
                                        <Tooltip
                                          title={
                                            conversationItem?.lockUserId ===
                                            authInfo?.id
                                              ? `Conversation locked by you`
                                              : `Conversation locked by ${
                                                  conversationItem?.userLocked !==
                                                    undefined &&
                                                  conversationItem?.userLocked !==
                                                    null
                                                    ? conversationItem?.userLocked
                                                    : ""
                                                } `
                                          }
                                        >
                                          <div
                                            style={{
                                              borderRadius: "50%",
                                              width: 35,
                                              height: 35,
                                              backgroundColor: "#FDF1F3",
                                              marginLeft: 8,
                                              display: "flex",
                                              justifyContent: "center",
                                              alignItems: "center",
                                            }}
                                          >
                                            <LockRedIcon
                                              color={
                                                conversationItem?.lock &&
                                                conversationItem?.lockUserId ===
                                                  authInfo?.id
                                                  ? "#0E9154"
                                                  : "#A9122B"
                                              }
                                              style={{ fontSize: 20 }}
                                            />
                                          </div>
                                        </Tooltip>
                                      )}
                                      {!conversationItem?.lock && (
                                        <div
                                          style={{
                                            width: 35,
                                            height: 35,
                                            marginLeft: 10,
                                          }}
                                        ></div>
                                      )}
                                    </div>
                                  )}
                                </div>
                              </div>
                            </>
                          )}
                        </div>

                        {below768 && (
                          <>
                            <Tooltip title="More options">
                              <div
                                style={{
                                  borderRadius: "50%",
                                  width: 30,
                                  height: 30,
                                  backgroundColor: "#fff",
                                  display: "flex",
                                  justifyContent: "center",
                                  alignItems: "center",
                                  paddingTop: 4,
                                }}
                              >
                                <Dropdown
                                  menu={{
                                    items,
                                  }}
                                  trigger={["click"]}
                                  onClick={() =>
                                    dispatch(
                                      setConversationSelected(conversationItem)
                                    )
                                  }
                                >
                                  <Button type="text" shape="circle">
                                    <DownOutlined />
                                  </Button>
                                </Dropdown>
                              </div>
                            </Tooltip>
                          </>
                        )}
                      </List.Item>
                    </>
                  )}
                />
              </InfiniteScroll>
            )}
          </div>
        </>
      </Space>
      <ModalForm
        title={t("inbox.chatList.optOutOrOut")}
        onCancel={() => setOpenBroadcast(false)}
        destroyOnClose={true}
        isOpen={openBroadcast}
        labelSubmit={t("label.save")}
        customWidth={800}
        footer={false}
      >
        <div style={{ width: "100%" }}>
          <OptInOrOutTable
            columns={columns}
            searchParam={{
              ...searchParam,
              workspaceId: authInfo?.workspaceId,
              customerId: conversationSelected?.customerId,
            }}
            setSearchParam={setSearchParam}
            isRefreshTable={isRefreshTable}
          />
        </div>
      </ModalForm>
    </>
  );
};
export default Conversation;
